import React from 'react';

const formatDateTime = (value) => {
  const date = new Date(String(value || '').replace(' ', 'T'));
  return Number.isNaN(date.getTime()) ? '—' : date.toLocaleString('tr-TR', { weekday:'short', day:'2-digit', month:'short', hour:'2-digit', minute:'2-digit' });
};

function RandevuRow({ item, onOpen }) {
  return (
    <button onClick={() => onOpen && onOpen(item)} style={{ width:'100%', textAlign:'left', border:'1px solid rgba(41,128,185,.22)', background:'#f4f9fd', borderRadius:5, padding:'10px 11px', cursor:'pointer', color:'var(--ink)' }}>
      <div style={{ display:'flex', justifyContent:'space-between', gap:8, alignItems:'baseline' }}>
        <span style={{ fontFamily:"'Barlow Condensed',sans-serif", fontSize:15, fontWeight:900, color:'var(--blue)' }}>{item.plaka}</span>
        <span style={{ fontFamily:"'Barlow Condensed',sans-serif", fontSize:11, fontWeight:800, color:'var(--muted)', textTransform:'uppercase' }}>{formatDateTime(item.randevu_tarihi)}</span>
      </div>
      <div style={{ fontSize:11, marginTop:3 }}>{[item.marka, item.model].filter(Boolean).join(' ') || 'Araç kartı'} · {item.firma_adi || '—'}</div>
      {item.not_alani && <div style={{ fontSize:10, color:'var(--muted)', marginTop:4 }}>{item.not_alani}</div>}
    </button>
  );
}

export default function RandevuOzetModal({ ozet, onClose, onAracAc }) {
  const today = Array.isArray(ozet?.bugun) ? ozet.bugun : [];
  const week = Array.isArray(ozet?.hafta) ? ozet.hafta : [];
  return (
    <>
      <div onClick={onClose} style={{ position:'fixed', inset:0, zIndex:12100, background:'rgba(12,22,35,.6)' }} />
      <div role="dialog" aria-modal="true" style={{ position:'fixed', zIndex:12101, top:'50%', left:'50%', transform:'translate(-50%,-50%)', width:'min(680px, calc(100vw - 24px))', maxHeight:'calc(100vh - 30px)', overflow:'auto', background:'var(--surface)', borderRadius:10, boxShadow:'0 22px 70px rgba(0,0,0,.35)' }}>
        <div style={{ padding:'19px 20px', borderBottom:'1px solid var(--border2)', display:'flex', justifyContent:'space-between', alignItems:'flex-start', gap:12 }}>
          <div>
            <div style={{ fontFamily:"'Barlow Condensed',sans-serif", fontSize:24, fontWeight:900, color:'var(--ink)' }}>📅 Randevu Özeti</div>
            <div style={{ fontSize:12, color:'var(--muted)', marginTop:3 }}>Bugünün ve bu haftanın planlanan araç randevuları</div>
          </div>
          <button onClick={onClose} style={closeStyle}>Kapat</button>
        </div>
        <div style={{ padding:20, display:'grid', gap:18 }}>
          <section>
            <div style={sectionTitle}>Bugün · {today.length} randevu</div>
            {!today.length ? <div style={emptyStyle}>Bugün planlanmış randevu yok.</div> : <div style={{ display:'grid', gap:7 }}>{today.map((item) => <RandevuRow key={item.id} item={item} onOpen={onAracAc} />)}</div>}
          </section>
          <section>
            <div style={sectionTitle}>Bu hafta · {week.length} randevu</div>
            {!week.length ? <div style={emptyStyle}>Bu hafta planlanmış randevu yok.</div> : <div style={{ display:'grid', gap:7 }}>{week.map((item) => <RandevuRow key={item.id} item={item} onOpen={onAracAc} />)}</div>}
          </section>
          <div style={{ fontSize:11, color:'var(--muted)' }}>Bir satıra dokunarak araç kartını açabilirsiniz.</div>
        </div>
      </div>
    </>
  );
}

const closeStyle = { background:'var(--ink)', color:'white', border:'none', borderRadius:4, padding:'8px 12px', cursor:'pointer', fontFamily:"'Barlow Condensed',sans-serif", fontSize:11, fontWeight:800, letterSpacing:.8, textTransform:'uppercase' };
const sectionTitle = { fontFamily:"'Barlow Condensed',sans-serif", fontSize:13, fontWeight:900, letterSpacing:1.1, textTransform:'uppercase', color:'var(--blue)', marginBottom:8 };
const emptyStyle = { padding:'12px', border:'1px dashed var(--border2)', borderRadius:5, color:'var(--muted)', fontSize:12 };
